import lottie from 'lottie-web' ;
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";

class Lottie {
    constructor({ element }) {
        this.element = element;
    }

    init() {
        var sectionOneLottie = lottie.loadAnimation( {
            container: this.element,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            // path: `https://create-apac.imgix.net/accenture-2022/scripts/lottie/${ this.element.dataset.src }/${ this.element.dataset.src }.json`
            path: `../scripts/lottie/${ this.element.dataset.src }/${ this.element.dataset.src }.json`,
        } );

        sectionOneLottie.addEventListener( 'data_ready', ( e ) => {
            // this.animation = gsap.timeline({ paused: true });
            // this.animation.to( { frame: 0 }, this.element.dataset.duration ?? 1, {
            //     frame: sectionOneLottie.totalFrames - 1,
            //     onUpdate: function() {
            //         sectionOneLottie.goToAndStop( Math.round( this.targets()[0].frame ), true );
            //         // sectionOneLottie.goToAndStop( Math.round( this.target.frame ), true );
            //     },
            //     ease: "linear",
            // } );

            const animationTrigger = ScrollTrigger.create({
                scroller: "[data-scroll-container]",
                trigger: document.querySelector( this.element.dataset.container ),
                // animation: animation,
                scrub: 0,
                start: "top center",
                end: "bottom bottom",
                pin: false,
                pinSpacing: false,
                markers: false,
                // onLeave: () => {
                //     console.log( 'a123123sfsf');
                // },
                onEnter: self => {
                    sectionOneLottie.play();
                    // this.animate();
                },
            } );

        } );

        // alert( 'yes' );
        // lscroll.update();
        // $( '.section--1-illustrator' ).addClass( 'is-inview' );
        // if(isTablet) {
        //     setTimeout(function(){
        //         sectionOneLottie.play();
        //     }, 800)
        // } else {
            // heroTl
            //     .to({frame: 0}, 1, {
            //         frame: sectionOneLottie.totalFrames-1,
            //         onUpdate: function() {
            //             if (this.target.frame/(sectionOneLottie.totalFrames-1)*100 > 95) {
            //                 document.dispatchEvent(new Event("2021-Accenture-A1-introanimation", {bubbles: true}));
            //             }
            //             sectionOneLottie.goToAndStop(Math.round(this.target.frame), true)
            //         },
            //         Ease:Linear.easeNone
            //     })
            //     .to($('.hero_btn'),0.1,{y:'-60px', opacity:0, ease: "none"}, '0')
        // }
    }

    animate() {
        this.animation.play();
    }
}

export default function () {
    document.querySelectorAll( '[data-content="lottie"]' ).forEach( ( element ) => {
        let lottie = new Lottie( { element } );
        lottie.init();
    } );
}